import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '@/Components/Icon/Icon';
export const ErrorCircle = () => {
    return (_jsx("button", { className: 'peer flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-danger text-danger-contrast', children: _jsx(Icon, { type: 'warning', size: "small" }) }));
};
